import Marquee from "react-fast-marquee";
import { INDUSTRIES } from "@/data/site";

export default function IndustryMarquee() {
  return (
    <section
      data-testid="marquee-section"
      aria-label="Industries served"
      className="relative py-16 md:py-20 border-t border-b border-slate-100 bg-white overflow-hidden"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {INDUSTRIES.concat(INDUSTRIES).map((label, i) => (
          <span key={`${label}-${i}`} className="marquee-item">
            <span className="font-display font-light text-4xl md:text-6xl text-slate-300 tracking-tight whitespace-nowrap">
              {label}
            </span>
            <span className="ml-12 text-blue-600 text-3xl md:text-5xl leading-none">◐</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
